module.exports = __webpack_public_path__ + "static/img/3.395f00e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/3.png
// module id = xcpy
// module chunks = 0